import React, {Fragment} from "react";
import AllWhite from "../components/AllWhite";
import {AppBar, Button, Typography, useTheme} from "@material-ui/core";
import logo from "../images/Sonasafe_R_214x74.png"
import Rest from "../helpers/Rest"
import PositionMonitor from "../helpers/PositionMonitor";
import {PanTool, People} from "@material-ui/icons";
import {setLoginPath} from "../pages/newLogin";

const EDIT_PATH = "/app/occupancy", ID = 0, MAX_OCCUPANCY = 3

class Occupancy extends React.Component{
    constructor(props) {
        super(props);
        const auth = this.props.location.state
        if (auth) {
            Rest.setToken(auth);
            this.state = {
                loaded: false,
                occupants: 0,
                minHeight: 0
            }
            this.getOccupancy()
        }
        else{
            this.props.history.replace(EDIT_PATH)
        }
    }

    componentWillUnmount() {
        window.clearInterval(this.poll)
    }

    componentDidMount() {
        this.poll = window.setInterval(this.getOccupancy.bind(this), 1000)
    }

    edit(){
        setLoginPath(EDIT_PATH)
        this.props.history.push({
            pathname: EDIT_PATH,
            state: this.props.location.state
        })
    }

    getOccupancy(){
        Rest.get("occupancy/zone/" + this.props.location.state.zone[ID]).then(
            reply => this.setState({
                loaded: true,
                occupants: reply
            })
        )
    }

    button(){
        return (
            <Button
                variant="contained"
                color="primary"
                onClick={this.edit.bind(this)}
            >
                Edit
            </Button>
        )
    }

    occupancy(colour){
        return (
            <Typography style={{color: colour, fontSize: "4vw", marginTop: this.props.theme.spacing(2)}}>
                {this.state.occupants} of {this.props.location.state.zone[MAX_OCCUPANCY]}
            </Typography>
        )
    }

    full(){
        const colour = this.props.theme.palette.error.main
        return (
            <Fragment>
                <Typography variant="h2" style={{fontSize:"3vw"}}>STOP ROOM FULL</Typography>
                {this.occupancy(colour)}
                <PanTool style={{
                    fill:colour,
                    width:"20vw",
                    height:"20vw"
                }} />
            </Fragment>
        )
    }

    hasSpace(){
        const colour = this.props.theme.palette.success.main
        return (
            <Fragment>
                <Typography variant="h2" style={{fontSize:"3vw"}}>Occupancy</Typography>
                {this.occupancy(colour)}
                <People style={{
                    fill:colour,
                    width:"20vw",
                    height:"20vw"
                }}/>
            </Fragment>
        )
    }

    render() {
        const {theme} = this.props
        return (
            <AllWhite>
                <AppBar position="fixed">
                    <div style={{
                        display:"flex",
                        justifyContent:"space-between",
                        alignItems:"center",
                        padding: `${theme.spacing(1)}px ${theme.spacing(2)}px`
                    }}>
                        <img src={logo} height={32}/>
                        {this.button()}
                    </div>
                </AppBar>
                <div style={{
                    height: theme.spacing(4)
                }} />
                <PositionMonitor>
                    {pos => this.setState({minHeight: window.innerHeight - pos.y})}
                </PositionMonitor>
                <div style={{
                    display: "flex",
                    flexDirection: "column",
                    minHeight: this.state.minHeight,
                    justifyContent: "center",
                    alignItems: "center"
                }}>
                    {this.state.occupants >= this.props.location.state.zone[MAX_OCCUPANCY] ? this.full() : this.hasSpace()}
                </div>
            </AllWhite>
        )
    }
}

export default function(props){
    const theme = useTheme()
    return <Occupancy theme={theme} {...props}/>
}